import { render, staticRenderFns } from "./note-customer.vue?vue&type=template&id=e59158c6&scoped=true"
import script from "./note-customer.vue?vue&type=script&lang=js"
export * from "./note-customer.vue?vue&type=script&lang=js"
import style0 from "./note-customer.vue?vue&type=style&index=0&id=e59158c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59158c6",
  null
  
)

export default component.exports